import Helper from "./Helper";

class ScrollTrigger {
  constructor(config = {}) {
    const {
    } = config;
    this.footer = document.querySelector('.footer');
    this.footerInner = document.querySelector('.footer__inner');
    this.storyTile = Array.prototype.slice.call(document.querySelectorAll('.ns-story-tile'));
    this.timelineAnchor = Array.prototype.slice.call(document.querySelectorAll('.ns-timeline-anchor'));
    this.content = document.querySelector('.content');
    this.totop = document.querySelector('.totop');

    if(this.storyTile.length > 0 && this.timelineAnchor.length > 0) {
      this.bindEvents();
    }
  }

  bindEvents() {
    this.addBarToBottom();
    this.updateTimelineOnScroll(this.footer);
    this.isFooterInViewport(this.footer);
    window.addEventListener("scroll", () => {
      this.updateTimelineOnScroll(this.footer);
      this.isFooterInViewport(this.footer);
    });

    window.addEventListener('resize', () => {
      this.updateTimelineOnScroll(this.footer);
      this.isFooterInViewport(this.footer);
    });
  }

  addBarToBottom() {
    const bardiv = document.createElement('div');
    const bardivRed = document.createElement('div');
    const monthdiv = document.createElement('div');
    const wrapper = document.createElement('div');
    Helper.addClass(bardiv, 'timeline-bar__bar');
    Helper.addClass(bardivRed, 'timeline-bar__bar-red');
    Helper.addClass(monthdiv, 'timeline-bar__label');
    Helper.addClass(wrapper, 'timeline-bar');

    wrapper.appendChild(monthdiv);
    wrapper.appendChild(bardiv);
    wrapper.appendChild(bardivRed);
    Helper.addBefore(wrapper, this.footer);
  }

  changeClassOfBar() {
    if(this.isFooterInViewport(this.footer) && !Helper.hasClass(bar, 'is-on-footer')) {
      let bar = document.querySelector('.timeline-bar');
      Helper.addClass(bar, 'is-on-footer');
    } else if(!this.isFooterInViewport(this.footer) && Helper.hasClass(bar, 'is-on-footer')) {
      Helper.removeClass(bar, 'is-on-footer');
    }
  }

  isFooterInViewport(footer) {
    let timelinebar = document.querySelector('.timeline-bar');
    if(Helper.isBottomOfViewportTop(footer) && !Helper.hasClass(timelinebar, 'is-on-footer')) {
      Helper.addClass(timelinebar, 'is-on-footer');
    } else if(!Helper.isBottomOfViewportTop(footer) && Helper.hasClass(timelinebar, 'is-on-footer')) {
      Helper.removeClass(timelinebar, 'is-on-footer');
    }
  }

  updateTimelineOnScroll(footer = 0) {
    this.timelineAnchor.forEach((item)=> {
      this.changeText(item);
    });

    let barLabel = document.querySelector('.timeline-bar__label');
    let labelWidth = barLabel ? barLabel.getBoundingClientRect().width : 0;
    let scrollTop = window.scrollY;
    let docHeight = labelWidth ? (this.content.offsetHeight + footer.offsetHeight + this.totop.offsetHeight + (labelWidth / 2)) : (this.content.offsetHeight + footer.offsetHeight + this.totop.offsetHeight);
    let winHeight = window.innerHeight;
    let scrollPercent = scrollTop / (docHeight - winHeight);
    let scrollPercentRounded = Math.round(scrollPercent * 100);
    let barRed = document.querySelector('.timeline-bar__bar-red');

    barRed.style.width = `calc(${scrollPercentRounded}% + ${labelWidth/2}px)`;
    barLabel.style.left = `calc(${scrollPercentRounded}% - ${labelWidth/2}px)`;
    barLabel.style.transform = `translateX(50%)`;
  }

  changeText(timelineAnchor) {
    if(Helper.isBottomOfViewport(timelineAnchor)) {
      let text = timelineAnchor.innerHTML;
      let barText = document.querySelector('.timeline-bar__label');
      barText.innerHTML = text;
    }
  }

}

export default ScrollTrigger;
